/* eslint-disable react/prop-types */
import React from "react";

export function PlayButton({ width, fill }) {
  return (
    <svg width={width} height={width} viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.6465 21.8341C37.3016 22.2384 37.2733 23.2002 36.5956 23.5654L1.52481 42.4609C0.847121 42.826 0.0282923 42.3206 0.0509273 41.5511L1.22229 1.73121C1.24492 0.961738 2.09204 0.505322 2.7471 0.909659L36.6465 21.8341Z"
        fill={fill || "#E3E2E2"}
      />
    </svg>
  );
}

export function PauseButton({ width, fill }) {
  return (
    <svg width={width} viewBox="0 0 24 24" fill="none">
      <g fillRule="nonzero">
        <path
          value="32236432-10"
          d="M4.3 20.8h5.029V3.2H4.3v17.6zM14.357 3.2v17.6h5.029V3.2h-5.029z"
          fill={fill || "#E3E2E2"}
        ></path>
        <path d="M1 1h22v22H1z"></path>
      </g>
    </svg>
  );
}

export function BackIcon({ width, fill }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} fill={"#E3E2E2"} viewBox="2 0 24 24">
      <g data-name="Layer 2">
        <g data-name="arrow-back">
          <rect width="24" height="24" opacity="0" transform="rotate(90 12 12)" />
          <path d="M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z" />
        </g>
      </g>
    </svg>
  );
}

export function CloseIcon({ width, fill }) {
  return (
    <svg width={width} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.5922 30.2561L23.2922 17.9157L35.6203 5.73451C36.1266 5.22853 36.1266 4.40396 35.6203 3.89797L32.1141 0.374805C31.8703 0.131182 31.5422 0 31.1953 0C30.8484 0 30.5203 0.140552 30.2766 0.374805L18.0047 12.5185L5.71406 0.384175C5.47031 0.140552 5.14219 0.00937069 4.79531 0.00937069C4.44844 0.00937069 4.12031 0.149922 3.87656 0.384175L0.379688 3.90734C-0.126562 4.41333 -0.126562 5.2379 0.379688 5.74388L12.7078 17.925L0.417188 30.2561C0.173438 30.4997 0.0328128 30.8277 0.0328128 31.1744C0.0328128 31.5211 0.164063 31.849 0.417188 32.0927L3.92344 35.6158C4.17656 35.8688 4.50469 36 4.84219 36C5.17031 36 5.50781 35.8782 5.76094 35.6158L18.0047 23.3222L30.2578 35.6065C30.5109 35.8594 30.8391 35.9906 31.1766 35.9906C31.5047 35.9906 31.8422 35.8688 32.0953 35.6065L35.6016 32.0833C35.8453 31.8397 35.9859 31.5117 35.9859 31.165C35.9766 30.8277 35.8359 30.4997 35.5922 30.2561Z"
        fill={fill || "#E3E2E2"}
      />
    </svg>
  );
}

export function DownloadIcon({ width, fill }) {
  return (
    <svg width={width} viewBox="0 0 42 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42 34.168V45.168C42 47.012 40.508 48.5013 38.6667 48.5013H3.33333C1.492 48.5013 0 47.012 0 45.168V34.168C0 32.3267 1.492 30.8347 3.33333 30.8347C5.17467 30.8347 6.66667 32.3267 6.66667 34.168V41.8347H35.3333V34.168C35.3333 32.3267 36.8253 30.8347 38.6667 30.8347C40.508 30.8347 42 32.3267 42 34.168ZM18.6427 37.024C19.2933 37.6747 20.148 38 21 38C21.8573 38 22.7053 37.6747 23.36 37.024L33.36 27.0267C34.664 25.7267 34.664 23.616 33.36 22.3133C32.0573 21.0107 29.9453 21.0107 28.6467 22.3133L24.3387 26.6227V3.33333C24.3387 1.492 22.8467 0 21.0053 0C19.164 0 17.672 1.492 17.672 3.33333V26.6227L13.3627 22.3133C12.06 21.0107 9.948 21.0107 8.64933 22.3133C7.34667 23.6173 7.34667 25.7267 8.64933 27.0267L18.6427 37.024Z"
        fill={fill || "#E3DEDE"}
      />
    </svg>
  );
}

export function Rewind({ width }) {
  return (
    <svg width={width} viewBox="0 0 64 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.3582 10.7677C20.3397 12.2131 19.7521 14.0925 17.9128 15.2676C10.7156 19.8409 6.17901 28.0195 6.17901 37.3298C6.17901 51.8442 17.3653 63.4612 31.9967 63.4612C46.628 63.4612 57.8143 51.8442 57.8143 37.3298C57.8143 24.6546 49.2885 14.2094 37.3945 11.7458V15.1875C37.3945 17.5743 35.0878 18.3955 33.2084 16.9901L24.6025 10.6074C24.3216 10.4123 24.0921 10.152 23.9335 9.84883C23.775 9.54568 23.6922 9.20867 23.6922 8.86658C23.6922 8.52448 23.775 8.18747 23.9335 7.88432C24.0921 7.58117 24.3216 7.32089 24.6025 7.12571L33.2118 0.71302C35.1279 -0.732421 37.3979 0.0887764 37.3979 2.55237V5.68026C52.4598 8.18391 64 21.5634 64 37.3264C64 54.9721 49.6023 69.4065 32 69.4065C14.3943 69.4065 6.35779e-07 54.9721 6.35779e-07 37.3264C-0.00108364 31.8852 1.38472 26.5336 4.02654 21.7768C6.66836 17.02 10.479 13.015 15.0987 10.1401C16.5475 9.23879 18.3868 9.3189 19.3649 10.7677H19.3582ZM22.8033 49.848C21.3178 49.848 20.2228 48.8298 20.2228 47.1875V31.7015H19.9891L17.5222 33.5376C16.8946 34.0483 16.5041 34.2052 15.8398 34.2052C14.8216 34.2052 13.8435 33.3439 13.8435 32.249C13.8435 31.3878 14.1573 30.7201 15.0953 30.0191L18.9309 27.3151C20.4164 26.2636 21.1609 25.9865 22.4527 25.9865C24.2888 25.9865 25.4638 27.2016 25.4638 28.9242V47.5847C25.4638 49.2238 24.3689 49.8513 22.8033 49.8513V49.848ZM38.88 50.045C34.8141 50.045 31.4492 48.2824 30.5479 45.6619C30.4711 45.2713 30.3543 44.8808 30.3543 44.567C30.3543 43.1983 31.2556 42.4138 32.5842 42.4138C33.6391 42.4138 34.2666 42.8478 34.6973 43.6289C35.4383 45.1912 36.8871 46.0925 39.0002 46.0925C41.4237 46.0925 43.1863 44.2565 43.1863 41.8296C43.1863 39.4028 41.6975 37.8004 39.4676 37.8004C38.0588 37.8004 37.3545 38.3078 36.6501 38.8153C35.8289 39.326 35.0878 39.9102 33.6791 39.9102C31.6829 39.9102 30.5879 38.8553 30.7849 36.8223L31.3691 29.1912C31.526 27.3552 32.8946 26.1401 34.8909 26.1401H45.2961C46.5879 26.1401 47.3691 26.9613 47.3691 28.2131C47.3691 29.3481 46.5112 30.0925 45.2994 30.0925H35.7121L35.1646 36.1547H35.4383C35.9491 35.2968 37.7083 34.085 40.4056 34.085C45.1024 34.085 48.2303 37.1328 48.2303 41.6727C48.2303 46.64 44.5149 50.045 38.8834 50.045H38.88Z"
        fill="#F3EDED"
      />
    </svg>
  );
}

export function Next({ width }) {
  return (
    <svg width={width} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0ZM43.8867 42.0802L28.8867 52.0802C28.4686 52.3584 27.9847 52.5 27.5 52.5C27.0953 52.5 26.69 52.4023 26.3202 52.2045C25.5072 51.7688 25 50.9216 25 50V30C25 29.0784 25.5072 28.2313 26.3202 27.7955C27.1331 27.3622 28.1195 27.4073 28.8867 27.92L43.8867 37.92C44.5825 38.3838 45 39.1637 45 40C45 40.8363 44.5825 41.6162 43.8867 42.0802ZM57.5 50C57.5 51.3806 56.3806 52.5 55 52.5H52.5C51.1194 52.5 50 51.3806 50 50V30C50 28.6194 51.1194 27.5 52.5 27.5H55C56.3806 27.5 57.5 28.6194 57.5 30V50Z"
        fill="#F3EDED"
      />
    </svg>
  );
}

export function Prev({ width }) {
  return (
    <svg width={width} viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.9992 80.2485C62.0902 80.3866 80.1104 62.5903 80.2485 40.4993C80.3866 18.4083 62.5903 0.388138 40.4993 0.250027C18.4084 0.111916 0.38816 17.9082 0.250049 39.9992C0.111938 62.0901 17.9082 80.1104 39.9992 80.2485ZM36.3756 38.1448L51.4379 28.2388C51.8577 27.9631 52.3425 27.8246 52.8272 27.8276C53.2319 27.8302 53.6365 27.9304 54.0051 28.1305C54.8154 28.5713 55.3173 29.4217 55.3115 30.3432L55.1865 50.3428C55.1807 51.2644 54.6682 52.1084 53.8525 52.5391C53.0369 52.9673 52.0508 52.9159 51.2868 52.3985L36.3496 42.3049C35.6568 41.8368 35.2441 41.0542 35.2494 40.218C35.2546 39.3818 35.677 38.6044 36.3756 38.1448ZM22.8121 30.14C22.8208 28.7594 23.9471 27.6471 25.3277 27.6557L27.8277 27.6713C29.2083 27.68 30.3206 28.8063 30.312 30.1869L30.1869 50.1865C30.1783 51.5671 29.052 52.6795 27.6714 52.6709L25.1714 52.6552C23.7908 52.6466 22.6785 51.5202 22.6871 50.1396L22.8121 30.14Z"
        fill="#F3EDED"
      />
    </svg>
  );
}

export function Forward({ width }) {
  return (
    <svg width={width} viewBox="0 0 64 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.6021 15.1898V11.7481C14.7081 14.2117 6.18235 24.657 6.18235 37.3321C6.18235 51.8466 17.3687 63.4636 32 63.4636C46.6313 63.4636 57.8176 51.8466 57.8176 37.3321C57.8176 28.0185 53.2777 19.8466 46.0839 15.2666C44.2445 14.0949 43.657 12.2188 44.6351 10.77C45.6132 9.32126 47.4525 9.24448 48.898 10.1425C53.5187 13.0173 57.3304 17.0226 59.9728 21.78C62.6153 26.5375 64.0013 31.8901 64 37.3321C64 54.9745 49.6023 69.4122 32 69.4122C14.3943 69.4089 0 54.9712 0 37.3288C0 21.5624 11.5402 8.18627 26.6021 5.68262V2.55139C26.6021 0.0877922 28.8721 -0.733406 30.7882 0.715374L39.3908 7.12806C39.6717 7.32324 39.9013 7.58353 40.0598 7.88668C40.2183 8.18983 40.3011 8.52684 40.3011 8.86893C40.3011 9.21103 40.2183 9.54804 40.0598 9.85119C39.9013 10.1543 39.6717 10.4146 39.3908 10.6098L30.7849 16.9858C28.9055 18.3945 26.5988 17.5733 26.5988 15.1865L26.6021 15.1898ZM42.4853 50.0473C37.044 50.0473 33.1717 45.5875 33.1717 37.9196C33.1717 30.2117 37.044 25.7519 42.4853 25.7519C48 25.7519 51.9124 30.2117 51.9124 37.9196C51.9124 45.5875 48 50.0473 42.4853 50.0473ZM21.5948 50.0473C17.3286 50.0473 13.8101 48.1679 12.9489 45.1569C12.8688 44.7663 12.792 44.4525 12.792 44.0219C12.792 42.6532 13.7701 41.832 15.0987 41.832C16.2737 41.832 16.938 42.3795 17.3286 43.3175C17.9562 45.1535 19.3248 46.1717 21.6716 46.2117C24.0985 46.2117 25.7776 44.7262 25.7776 42.77C25.7409 40.8539 24.1352 39.522 21.7117 39.522H20.3029C19.208 39.522 18.2666 38.7408 18.2666 37.6459C18.2666 36.5109 19.1279 35.6497 20.3029 35.6497H21.5948C23.7079 35.6497 25.1533 34.3578 25.1533 32.5985C25.1133 30.8393 23.7079 29.5875 21.6315 29.5875C19.7154 29.5875 18.27 30.6424 17.7592 32.4416C17.3687 33.3797 16.6643 33.9271 15.5694 33.9271C14.1607 33.9271 13.2226 33.0692 13.2226 31.7373C13.2226 31.2699 13.2627 30.9929 13.3795 30.6023C14.1607 27.668 17.2919 25.7519 21.7117 25.7519C26.8759 25.7519 30.1607 28.3357 30.2408 31.8942C30.3175 35.0254 27.6169 36.9015 25.7409 37.1752V37.4089C28.0108 37.6826 30.9051 39.4051 30.9818 43.0438C31.062 47.3834 26.9126 50.0473 21.5948 50.0473ZM42.5253 45.7811C45.1425 45.7811 46.825 43.0438 46.825 37.9196C46.825 32.7955 45.1425 30.0548 42.522 30.0548C39.8247 30.0548 38.1423 32.7922 38.1423 37.9196C38.1423 43.0438 39.8247 45.7811 42.522 45.7811H42.5253Z"
        fill="#F3EDED"
      />
    </svg>
  );
}

export function ShareIcon({ width }) {
  return (
    <svg width={width} viewBox="0 0 32 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2144 9.8233L13.913 7.12487V28.5212C13.913 29.6737 14.8474 30.6081 16 30.6081C17.1525 30.6081 18.0869 29.6737 18.0869 28.5212V7.12501L20.7852 9.8233C21.1927 10.2308 21.7267 10.4346 22.2608 10.4346C22.795 10.4346 23.3291 10.231 23.7364 9.8233C24.5515 9.00828 24.5515 7.68696 23.7364 6.87193L17.476 0.611339C17.427 0.562504 17.3757 0.516313 17.3224 0.472626C17.2993 0.453704 17.275 0.437287 17.2514 0.419617C17.2206 0.396383 17.1904 0.37273 17.1582 0.351165C17.1294 0.331826 17.0995 0.31513 17.0699 0.297461C17.0411 0.28007 17.0128 0.261983 16.9831 0.246122C16.9529 0.229983 16.922 0.216348 16.8911 0.201878C16.8601 0.18713 16.8297 0.171826 16.7979 0.158609C16.7681 0.146226 16.7378 0.136348 16.7076 0.125496C16.6736 0.113252 16.6401 0.100174 16.6052 0.0897391C16.5751 0.0806957 16.5447 0.0740174 16.5145 0.0663652C16.4788 0.0573217 16.4435 0.0473043 16.4072 0.0402087C16.3724 0.0333913 16.3372 0.0293565 16.3022 0.0242087C16.2699 0.0196174 16.2381 0.0134957 16.2055 0.0102957C16.1412 0.00403478 16.0768 0.000973913 16.0122 0.000556522C16.008 0.000556522 16.004 0 15.9998 0C15.9958 0 15.9916 0.000556522 15.9876 0.000556522C15.923 0.000834783 15.8585 0.00403478 15.794 0.0102957C15.762 0.0134957 15.731 0.0194783 15.6994 0.0239304C15.6635 0.0290783 15.6276 0.0332522 15.5922 0.0403478C15.5568 0.0473043 15.5226 0.0570435 15.488 0.0658087C15.4565 0.0737391 15.4251 0.0805565 15.3939 0.0898783C15.3604 0.100035 15.3277 0.112696 15.2948 0.124522C15.2635 0.135791 15.232 0.146087 15.2011 0.158887C15.1705 0.171548 15.1412 0.186435 15.1115 0.200487C15.0795 0.215513 15.0472 0.229843 15.0158 0.246539C14.9874 0.261704 14.9607 0.278956 14.933 0.295513C14.9019 0.313878 14.8708 0.331409 14.8406 0.351583C14.8104 0.371756 14.7822 0.394296 14.7531 0.415861C14.7275 0.434922 14.7015 0.452591 14.6767 0.473043C14.6259 0.514643 14.5773 0.558748 14.5307 0.6048C14.5285 0.607026 14.5262 0.608835 14.5238 0.611061L8.26264 6.87193C7.44761 7.68696 7.44761 9.00828 8.26264 9.8233C9.07808 10.6383 10.3995 10.6381 11.2144 9.8233Z"
        fill="#F3EDED"
      />
      <path
        d="M29.913 16.9131H24.3478C23.1953 16.9131 22.2609 17.8475 22.2609 19C22.2609 20.1526 23.1953 21.087 24.3478 21.087H27.8261V41.9566H4.17391V21.087H7.65217C8.80473 21.087 9.73913 20.1526 9.73913 19C9.73913 17.8475 8.80473 16.9131 7.65217 16.9131H2.08696C0.9344 16.9131 0 17.8475 0 19V44.0435C0 45.1961 0.9344 46.1305 2.08696 46.1305H29.913C31.0656 46.1305 32 45.1961 32 44.0435V19C32 17.8475 31.0656 16.9131 29.913 16.9131Z"
        fill="#F3EDED"
      />
    </svg>
  );
}

export function OpenLink({ width }) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      width={width}
      fill="#F3EDED"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 331.708 331.708"
    >
      <g>
        <path
          d="M222.685,284.287H47.419V109.02h102.502l47.421-47.419H5c-2.761,0-5,2.239-5,5v260.105c0,2.761,2.239,5,5,5h260.104
      c2.761,0,5-2.239,5-5v-192.34l-47.419,47.418V284.287z"
        />
        <path
          d="M330.244,1.467c-1.149-1.149-2.783-1.671-4.387-1.391L194.44,22.786c-1.84,0.318-3.35,1.635-3.915,3.415
      c-0.564,1.78-0.09,3.727,1.23,5.047l30.971,30.971l-79.517,79.516c-1.953,1.953-1.953,5.119,0,7.071l39.688,39.689
      c0.938,0.938,2.21,1.464,3.536,1.464c1.326,0,2.598-0.527,3.536-1.464l79.517-79.516l30.97,30.971
      c1.32,1.32,3.268,1.794,5.047,1.23c1.78-0.564,3.097-2.074,3.414-3.915L331.634,5.854C331.912,4.253,331.393,2.617,330.244,1.467z"
        />
      </g>
    </svg>
  );
}

export const ArrowUp = ({ width, fill }) => {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 330 330"
      width={width}
      fill={fill || "#E3E2E2"}
      stroke={fill || "#E3E2E2"}
      strokeWidth={15}
    >
      <path
        d="M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394
 l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393
 C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z"
      />
    </svg>
  );
};

export const ArrowDown = ({ width, fill }) => {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 330 330"
      width={width}
      fill={fill || "#E3E2E2"}
      stroke={fill || "#E3E2E2"}
      strokeWidth={15}
      transform="rotate(180)"
    >
      <path
        d="M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394
 l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393
 C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z"
      />
    </svg>
  );
};

export const LibraryIcon = ({ width, fill }) => {
  return (
    <svg fill={fill || "#e3e2e2"} width={width} x="0px" y="0px" viewBox="0 0 26 25">
      <g>
        <path d="M22,4H0v16h22V4z M9,16V8l6,4L9,16z" />
        <polygon points="24,2 2,2 2,3 23,3 23,18 24,18  " />
        <polygon points="4,1 25,1 25,16 26,16 26,0 4,0  " />
      </g>
    </svg>
  );
};

export const AddToQueue = ({ width, fill }) => {
  return (
    <svg width={width} viewBox="0 0 24 24">
      <path
        fill={fill || "#E3E2E2"}
        d="M13 10H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm5 8v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3zM3 16h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1z"
      />
    </svg>
  );
};

export const PresentInQueueIcon = ({ width, fill }) => {
  return (
    <svg width={width} viewBox="0 0 24 24">
      <path
        fill={fill || "#E3E2E2"}
        d="M13 10H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zM3 16h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm19.21-3.79l.09.09c.39.39.39 1.02 0 1.41l-5.58 5.59c-.39.39-1.02.39-1.41 0l-3.09-3.09c-.39-.39-.39-1.02 0-1.41l.09-.09c.39-.39 1.02-.39 1.41 0l2.3 2.3 4.78-4.79c.38-.4 1.02-.4 1.41-.01z"
      />
    </svg>
  );
};

export const QueueIcon = ({ width, fill }) => {
  return (
    <svg width={width} viewBox="0 0 22 22">
      <path
        fill={fill || "#E3E2E2"}
        d="M5 10h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0-4h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0 8h6c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm9 .88v4.23c0 .39.42.63.76.43l3.53-2.12c.32-.19.32-.66 0-.86l-3.53-2.12c-.34-.19-.76.05-.76.44z"
      />
    </svg>
  );
};

export function LockIcon({ width, fill }) {
  return (
    <svg height={width} width={width} fill={fill} x="0px" y="0px" viewBox="0 0 1000 1000">
      <g>
        <g>
          <path d="M745,438.8V255c0-135.1-109.9-245-245-245c-135.1,0-245,109.9-245,245v183.8c-67.7,0-122.5,54.9-122.5,122.5v306.3c0,67.7,54.8,122.5,122.5,122.5h490c67.6,0,122.5-54.8,122.5-122.5V561.2C867.5,493.6,812.6,438.8,745,438.8z M530.6,735.6v101.3c0,16.9-13.7,30.6-30.6,30.6s-30.6-13.7-30.6-30.6V735.6c-18-10.6-30.6-29.4-30.6-51.9c0-33.9,27.4-61.3,61.2-61.3c33.8,0,61.3,27.4,61.3,61.3C561.3,706.2,548.6,725,530.6,735.6z M622.5,438.8h-245V255c0-67.6,54.9-122.5,122.5-122.5c67.5,0,122.5,54.9,122.5,122.5V438.8L622.5,438.8z" />
        </g>
      </g>
    </svg>
  );
}

export function ShowNotes({ width, fill }) {
  return (
    <svg height={width} viewBox="0 0 24 24" width={width}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill={fill || "#e3e2e2"}
        d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
      />
    </svg>
  );
}
